import {Component, Input, OnInit} from '@angular/core';
import {ConfiguratorUriParameterService} from '@dcp/configurator';
import {CommercialModelMessagePlaceholder} from '@app/model/dcp-config-service/commercial-model-config';
import {TranslationService} from '@spartacus/core';
import {Observable} from 'rxjs';
import {DcpCartConfigurationForm} from '@app/cart/dcp-cart-configuration.model';

@Component({
  selector: 'dcp-additional-information-message',
  templateUrl: './additional-information-message.component.html',
  styleUrls: ['./additional-information-message.component.scss'],
})
export class AdditionalInformationMessageComponent implements OnInit {

  @Input() configuration: DcpCartConfigurationForm;
  @Input() notificationText: string;
  @Input() placeholders: CommercialModelMessagePlaceholder[];
  @Input() messageType: string;
  linkText: string;
  modalContent: string;
  modalHeading: string;
  infoMessage$: Observable<string>;

  isModalOpen: boolean = false;

  constructor(
    private uriService: ConfiguratorUriParameterService,
    private translationService: TranslationService,
  ) {
  }

  ngOnInit(): void {
    this.getPlaceholder(this.placeholders);
  }

  showInformation() {
    this.isModalOpen = true;
  }

  getPlaceholder(placeholders: CommercialModelMessagePlaceholder[]) {
    const placeholderTexts = {};
    if (placeholders) {
      placeholders.forEach((placeholder, index) => {
        switch (placeholder.type) {
          case 'queryParam':
            placeholderTexts[index] = this.uriService.getQueryParam(placeholder.path) || this.configuration.data[placeholder.path];
            break;
          case 'modal':
            this.linkText = placeholder.text;
            this.modalContent = placeholder.modalContent;
            this.modalHeading = placeholder.modalTitle;
            break;
          default:
            console.error('Invalid message configuration. Placeholder type: ', placeholder.type); // NOSONAR
        }
      });
      this.infoMessage$ = this.translationService.translate(this.notificationText, placeholderTexts);
    }
  }

  closeEditModal() {
    this.isModalOpen = false;
  }
}
